import { Anchor, Group, Image, Stack, Text } from '@mantine/core'
import { redactMediaProps } from '@phoenix-web/utils/general'
import { UploadedDealFiles } from '@phoenix-web/ux-gql/queries'

interface BoxPropertyPhotosProps {
  photos: UploadedDealFiles
  viewPhotosUrl: string
}

export default function BoxPropertyPhotos({ photos, viewPhotosUrl }: BoxPropertyPhotosProps) {
  return (
    <Stack
      gap="lg"
      style={{ borderRadius: 'var(--mantine-radius-sm)' }}
      bd="1px solid light-gray.6"
      w="100%"
      p="lg"
      pb="xl"
    >
      <Text fw={700} size="lg">
        Departing Property Photos
      </Text>

      <Group gap="md" wrap="nowrap" align="flex-start">
        {photos.slice(0, 3).map((photo, index) => (
          <Anchor
            key={index}
            href={viewPhotosUrl}
            style={{
              flex: '1',
              width: '30%',
            }}
          >
            <Image
              {...redactMediaProps}
              src={photo.presigned_url}
              alt={`Property photo ${index + 1}`}
              style={{
                borderRadius: 'var(--mantine-radius-sm)',
                width: '100%',
                height: '100px',
                objectFit: 'cover',
                cursor: 'pointer',
                transition: 'opacity 0.2s ease',
              }}
            />
          </Anchor>
        ))}
      </Group>

      <Text
        component="a"
        href={viewPhotosUrl}
        fw={500}
        size="sm"
        style={{
          textDecoration: 'underline',
          cursor: 'pointer',
        }}
      >
        View Photos
      </Text>
    </Stack>
  )
}
